// extracted by mini-css-extract-plugin
export default {"item":"BcQdf","label":"MwyG2","body":"HAKRL"};